export const SEARCHBAR_CLICK_TAB = "SEARCHBAR_CLICK_TAB";
export const clickTab = tab => ({ type: SEARCHBAR_CLICK_TAB, tab });
